import React, {useState} from 'react';
import {Button, Row, Col, Flex, message} from "antd";
import {ExportPreviewTable} from "./ExportPreviewTable";
import {DownloadDropDown} from "./DownloadDropDown";
import SqlEditor from "../../../components/SqlEditor/SqlEditor";
import {Spacer} from "../../../components/DesignSystem/Spacer/Spacer";
import {TablesTabs} from "../project/backups/chats/detail/TablesTabs";
import {chatService} from "../../../services/chatService";
import {SqlAssistantModal} from "./modal/SqlAssistantModal";
import {SqlExplainModal} from "./modal/SqlExplainModal";
import {SqlImproveFixModal} from "./modal/SqlImproveFixModal";

export const ExportPreview = ({chatId, reloadData, fetchData, columns, onFilterData, onDownload, code, tables}) => {

    const [sql, setSql] = useState(code || "");
    const [previewTable, setPreviewTable] = useState(null);
    const [previewTableColumns, setPreviewTableColumns] = useState([]);
    const [reloadPreviewTable, setReloadPreviewTable] = useState(false);
    const [selectedTab, setSelectedTab] = useState("results");
    const [showAiAssistant, setShowAiAssistant] = useState(false);
    const [showExplainModal, setShowExplainModal] = useState(false);
    const [showImproveFixModal, setShowImproveFixModal] = useState(false);

    const handleCodeChange = (value) => {
        setSql(value);
    }

    const handleRunClick = () => {
        handleTableChange("results");
        onFilterData(sql);
    }

    const handleAiAssistantClick = () => {
        setShowAiAssistant(true);
    }

    const handleTableChange = (key) => {
        if (key === "results") {
            setPreviewTable(undefined);
            setPreviewTableColumns(columns);
            setReloadPreviewTable(Math.random());
        } else {
            setPreviewTable(key);
            setPreviewTableColumns(tables.find(table => table.tableName === key)?.columns || []);
            setReloadPreviewTable(Math.random());
        }
        setSelectedTab(key);
    }

    const fetchPreviewData = (page, size, sort) => {
        return chatService.fetchData(chatId, previewTable, page, size, "select * from " + previewTable, sort).then(response => {
            const value = {
                data: {...response.data.page}
            }
            return Promise.resolve(value);
        })
    }

    const handleAiGeneratedQuery = (query) => {
        setShowAiAssistant(false);
        setSql(query);
        handleTableChange("results");
        onFilterData(query);
    }

    const handleCloseExplainModal = () => {
        setShowExplainModal(false);
    }

    const handleExplainClick = () => {
        setShowExplainModal(true);
    }

    const handleImproveFixClick = () => {
        setShowImproveFixModal(true);
    }

    return <>
        <Spacer/>
        <SqlEditor initialCode={code} onChange={handleCodeChange} height="200px"/>
        <Spacer border={true}/>
        <Row>
            <Col sm={20}>
                <Flex>
                    <Button type={"primary"} title={"Run Query"} style={{width: '100px'}} onClick={handleRunClick}>Run</Button>
                    {/*<Button type={"primary"} style={{marginLeft: '10px', width: '100px'}} title={"Explain query"} onClick={handleExplainClick}>Explain</Button>*/}
                    {/*<Button type={"primary"} style={{marginLeft: '10px', width: '100px'}} title={"Filter"} onClick={handleRunClick}>Adjust</Button>*/}
                    {/*<Button type={"primary"} style={{marginLeft: '10px', width: '100px'}} title={"Improve & Fix"} onClick={handleImproveFixClick}>Improve & Fix</Button>*/}
                    <Button type={"default"} style={{marginLeft: '10px', width: '100px'}} onClick={handleAiAssistantClick}>AI Assistant</Button>
                </Flex>
            </Col>
            <Col sm={4} style={{textAlign: 'right', paddingLeft: '30px'}}>
                <DownloadDropDown onDownload={onDownload}/>
            </Col>
        </Row>
        <Spacer border={true}/>
        <TablesTabs tables={tables} onChange={handleTableChange} selectedTab={selectedTab}/>
        {previewTable === undefined && <ExportPreviewTable columnNames={columns} fetchData={fetchData} reloadData={reloadData}/>}
        {previewTable && <ExportPreviewTable columnNames={previewTableColumns} fetchData={fetchPreviewData} reloadData={reloadPreviewTable}/>}
        {showAiAssistant && <SqlAssistantModal tables={tables} chatId={chatId} onQuery={handleAiGeneratedQuery} onClose={() => setShowAiAssistant(false)}/>}
        {showExplainModal && <SqlExplainModal sql={code} chatId={chatId} onClose={handleCloseExplainModal}/>}
        {showImproveFixModal && <SqlImproveFixModal sql={code} chatId={chatId} onClose={() => setShowImproveFixModal(false)}/>}
    </>
}